.row {
  font-size: 14px;
  display: flex;
  align-items: center;
  position: relative;

  .tooltip-for-labeled-row {
    position: absolute;
    left: 28px;
    top: 4px;
  }

  label {
    padding-right: 10px;
  }

  .children {
    flex: 1;
    min-width: 0;
  }
}
